import { Icon, BasicIconName } from '@musinsa/pbo-assets'
import { Typography } from '@musinsa/layer-components-desktop'
import { HStack, VStack } from '@musinsa/mwms-ds'

export const NoRowsOverlayComponent = ({
  mainContent = '검색 조건을 설정해 주세요.',
  subContent = '상단 필터를 설정해서 조회해 주세요.',
  iconName = 'ic-paper',
  bottomButtons,
}: {
  mainContent?: string
  subContent?: string
  iconName?: BasicIconName
  bottomButtons?: React.ReactNode
}) => {
  return (
    <VStack align="center" justify="center" gap={16}>
      <Icon name={iconName} filled color="#E0E0E0" size={68} />
      <VStack gap={8} align="center" justify="center">
        <Typography name="base-text-xl-semibold" colorToken="fg">
          {mainContent}
        </Typography>
        <Typography name="base-text-l" colorToken="fg-low">
          {subContent}
        </Typography>
      </VStack>
      {bottomButtons && (
        <HStack gap={8} align="center" justify="center">
          {bottomButtons}
        </HStack>
      )}
    </VStack>
  )
}
